import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'

import Note from '@src/data/note'
import { Icon } from '@src/elements/icon/icon'
import ApiClient from '@src/lib/api_client'
import { NotificationTypes } from '@src/util/constants'
import { ConfirmModal } from '@src/elements/modal/confirm-modal'
import { API } from '@src/lib/api_path'
import { Body1, Body2, Subtitle1 } from '@src/elements/typography/typography'
import { Popover } from '@src/components/popover/popover'
import { OptionGroup } from '@src/elements/select/option-group'
import { MenuButton } from '@src/elements/button/button'
import { convertToLocalDate } from '@src/util/date-format'

import './note-row.sass'
import { noop } from '@src/util/noop'
import { CheckupState } from '@src/data/checkup'

@Component({
  computed: {
    filter () {
      return this.$store.state.memberNoteFilters.word || ''
    },
    storeCheckup () {
      return this.$store.state.checkup
    }
  }
})
export class NoteRow extends Vue {

  @Prop({ required: true })
  note: Note

  // not used: the checkup of the store decides, the lists still pass theirs (null outside of a checkup)
  @Prop({ required: false, default: null })
  checkup: any

  @Prop({ required: false, default: noop })
  removeCallback: (id) => void

  private apiClient: ApiClient
  private showConfirmPopup: boolean = false

  private filter: string
  private storeCheckup: any

  constructor () {
    super()
    this.apiClient = new ApiClient(API.TRAINERS_API.MEMBERS)
  }

  showRemoveConfirm () {
    this.showConfirmPopup = true
  }

  remove (confirm: boolean) {
    if (confirm === true) {
      this.apiClient.delete(`${this.$route.params.id}/notes/${this.note.id}`)
        .then(() => {
          this.$store.dispatch('showToast', { message: this.$t('PAGE.MEMBERS.NOTES.DELETE_SUCCESS'), fadeOut: true })
          this.removeCallback(this.note.id)
        })
        .catch(error => console.error('failed to remove workout', error))

    }
    this.showConfirmPopup = false
  }

  edit () {
    this.$store.dispatch('setNote', JSON.parse(JSON.stringify(this.note)))
  }

  render (h: CreateElement) {
    const { path } = this.$route || { path: undefined }

    function highlightSearch (haystack: string, needle: string) {
      const idx = haystack.toLowerCase().indexOf(needle)
      if (idx !== -1) {
        return <span>
          {haystack.substring(0, idx)}
          <span class='highlight'>{haystack.substring(idx, idx + needle.length)}</span>
          {haystack.substring(idx + needle.length)}
        </span>
      } else {
        return haystack
      }
    }
    const isCheckup = path && path.includes('checkup')

    const tags = this.note.tags.map(tag => {
      return <Body2 class='note-tag'>{highlightSearch(tag, this.filter.toLowerCase())}</Body2>
    })
    return <div class='note-row'>
      <Subtitle1 class={'title'}>
        <span>{this.note.createdAt ? convertToLocalDate(this.note.createdAt) : ''}</span>
        {!isCheckup || this.storeCheckup && this.storeCheckup.state !== CheckupState.COMPLETED ?
        <MenuButton>
          <Popover>
            <OptionGroup>
              <div onClick={this.edit} ref='editBtn'><Subtitle1>{this.$t('PAGE.MEMBERS.NOTES.EDIT')}</Subtitle1></div>
              <div onClick={this.showRemoveConfirm} ref='deleteBtn'><Subtitle1>{this.$t('PAGE.MEMBERS.NOTES.REMOVE')}</Subtitle1></div>
            </OptionGroup>
          </Popover>
        </MenuButton>
        : null}
      </Subtitle1>

      <Body1>{highlightSearch(this.note.text, this.filter.toLowerCase())}</Body1>

      {this.note.tags.length > 0 ? <div class='note-tags'><Icon name='util/label' />{tags}</div> : null}

      {this.showConfirmPopup ?
        <ConfirmModal show={true}
                      closeCallback={this.remove}
                      message={this.$t('PAGE.MEMBERS.NOTES.CONFIRM_REMOVE')}
                      type={NotificationTypes.CONFIRM} /> : null}
    </div>
  }
}
